/* eslint-disable react-hooks/exhaustive-deps */
import {
  useState,
  useEffect,
  memo,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid, useMediaQuery, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import AutoCompleteInput from "Components/FormComponents/AutoCompleteInput";
import TextFieldInput from "Components/FormComponents/TextFieldInput";
import NumberInput from "Components/FormComponents/NumberInput";
import {
  getCarInfoCompanyByType,
  getCarModelCodeByType,
  getCarInfoModelByType,
} from "../../../MainBody/api";
import { IS_UPDATING, IS_UPDATING_VI_CODE } from "./constant";
import { normalizeString } from "Common/common";
import {
  SelectOption,
  CarTypeCompanyInfo,
  CarModelCodeType,
  CarInfoModelType,
} from "./type";
import { ChildRef } from "Components/MainBodyV2/CarType/type";
import { listHideCarBrand } from "./constant";
import { listOptionManufactureYear } from "Components/MainBodyV2/CarType/listOption";
import { checkIsModelCode, normalizeText } from "Common/common";
import { isEmpty } from "lodash";
import { OTHER } from "./constant";
import { ResultCarPrice } from "Components/Result/types";

interface ISpecializedVehicleForm {
  isLoadCarPrice: boolean;
  onValueChange: (value: string) => void;
  dataFormImage: any;
  setDataFromImage: any;
  setCarPriceValue: React.Dispatch<React.SetStateAction<ResultCarPrice>>;
}

const SpecializedVehicleForm = forwardRef<ChildRef, ISpecializedVehicleForm>(
  (
    {
      isLoadCarPrice,
      onValueChange,
      dataFormImage,
      setDataFromImage,
      setCarPriceValue,
    },
    ref,
  ) => {
    const { state, pathname } = useLocation();
    const navigate = useNavigate();
    const isTabletOrMobile = useMediaQuery("(max-width: 1050px)");
    const { t } = useTranslation();
    const theme = useTheme();

    const [openCarModel, setOpenCarModel] = useState<boolean>(false);

    const [selectedCarCompany, setSelectedCarCompany] = useState<SelectOption>({
      id: "",
      label: "",
    });
    const [selectedModel, setSelectedModel] = useState<SelectOption>({
      id: "",
      label: "",
    });
    const [selectedModelCode, setSelectedModelCode] = useState<SelectOption>({
      id: "",
      label: "",
    });
    const [selectedManufactured, setSelectedManufactured] =
      useState<SelectOption>({ id: "", label: "" });
    const [weight, setWeight] = useState<string>("");
    const [specializedVehicle, setSpecializedVehicle] = useState<string>("");
    const [otherValue, setOtherValue] = useState<string>("");
    const [listCarCompany, setListCarCompany] = useState<SelectOption[]>([]);
    const [listCarInfoModel, setListCarInfoModel] = useState<SelectOption[]>(
      [],
    );
    const [listModelCode, setListModelCode] = useState<SelectOption[]>([]);

    const [open, setOpen] = useState<boolean>(false);
    const [modelCodeInput, setModelCodeInput] = useState<string>("");
    const resetSelect = () => {
      setCarPriceValue((prev: any) => ({
        ...prev,
        carValue: 0,
        maxPrice: null,
        minPrice: null,
        minListedPrice: null,
        maxListedPrice: null,
        hanoiOnRoadPrice: null,
        generalOnRoadPrice: null,
        hcmOnRoadPrice: null,
      }));
      setSelectedCarCompany({ id: "", label: "" });
      setSelectedModel({ id: "", label: "" });
      setSelectedModelCode({ id: "", label: "" });
      setSelectedManufactured({ id: "", label: "" });
      setDataFromImage(null);
      setWeight("");
    };

    useImperativeHandle(ref, () => ({
      triggerAction: handleTrigger,
    }));

    const handleTrigger = () => {
      resetSelect();
    };

    useEffect(() => {
      if (otherValue !== "") {
        if (checkIsModelCode(otherValue, listModelCode) !== -1) {
          setSelectedModelCode(
            listModelCode[checkIsModelCode(otherValue, listModelCode)],
          );
        }
      }
    }, [otherValue]);

    useEffect(() => {
      if (!state && !isLoadCarPrice) {
        if (selectedModelCode?.id === "") {
          setWeight("");
          setSpecializedVehicle("");
          setSelectedManufactured({ id: "", label: "" });
          return;
        }
        if (selectedModelCode?.id === OTHER) {
          if (dataFormImage && dataFormImage?.predictedYear) {
            const year = listOptionManufactureYear.find(
              (item) => item.id === dataFormImage.predictedYear.toString(),
            );
            if (year) setSelectedManufactured(year);
          }
        } else {
          setOtherValue("");
          setWeight(
            selectedModelCode?.payload
              ? selectedModelCode.payload.toString()
              : "",
          );
          setSpecializedVehicle(
            selectedModelCode?.carTypeName ? selectedModelCode.carTypeName : "",
          );
          if (dataFormImage && dataFormImage?.predictedYear) {
            const year = listOptionManufactureYear.find(
              (item) => item.id === dataFormImage.predictedYear.toString(),
            );
            if (year) setSelectedManufactured(year);
          }
        }
      }
    }, [selectedModelCode]);

    useEffect(() => {
      (async () => {
        const getCarInfo: CarTypeCompanyInfo[] = await getCarInfoCompanyByType(
          "specialized",
          1000,
        );
        let newListOption: SelectOption[] = [];
        if (getCarInfo && getCarInfo.length > 0) {
          getCarInfo.forEach((company) => {
            const option: SelectOption = {
              id: company.companyKey,
              label: company.companyName,
            };

            newListOption.push(option);
          });
          listHideCarBrand.forEach((element) => {
            newListOption = newListOption.filter(
              (option) => option.id !== element,
            );
          });

          setListCarCompany(newListOption);
        }
        if (dataFormImage) {
          const nameOfCarCompany = dataFormImage.predictedCarCompany;
          const findCarCompany = newListOption.find((company) =>
            company?.label?.includes(nameOfCarCompany),
          );

          if (findCarCompany) {
            setSelectedCarCompany(findCarCompany);
          } else {
            setSelectedCarCompany({ id: OTHER, label: nameOfCarCompany });
          }
        }
      })();
    }, [listHideCarBrand, dataFormImage]);

    useEffect(() => {
      if (selectedCarCompany && selectedCarCompany.id !== "") {
        setSelectedModel({ id: "", label: "" });
        setModelCodeInput("");
        setListCarInfoModel([]);
        if (selectedCarCompany.id === OTHER) {
          if (state && state?.model) {
            setSelectedModel(state?.model);
            return;
          }
          if (dataFormImage && dataFormImage?.predictedCarModel) {
            setSelectedModel({
              id: OTHER,
              label: dataFormImage?.predictedCarModel,
            });
            return;
          }
          setSelectedModel({ id: OTHER, label: "" });
          return;
        }
        (async () => {
          const listCarInfoModel: CarInfoModelType[] =
            await getCarInfoModelByType(
              "specialized",
              selectedCarCompany?.id || "",
              1000,
            );
          const newListOption: SelectOption[] = [];

          if (listCarInfoModel && listCarInfoModel.length > 0) {
            listCarInfoModel.forEach((model) => {
              const option: SelectOption = {
                id: `${model.versionKey}${model.modelCode}`,
                label: `${model.versionName} (${model.modelCode})`,
                versionKey: model.versionKey,
                modelCode: model.modelCode,
              };
              newListOption.push(option);
            });

            setListCarInfoModel(newListOption);
            if (state && state?.model) setSelectedModel(state?.model);
          }

          if (dataFormImage) {
            const nameOfCarModel = dataFormImage.predictedCarModel;
            const findCarModel =
              nameOfCarModel !== IS_UPDATING
                ? newListOption.find((model) =>
                    normalizeText(model?.label).includes(
                      normalizeText(nameOfCarModel),
                    ),
                  )
                : newListOption.find(
                    (model) =>
                      model?.id ===
                      normalizeString(dataFormImage.predictedCarVersion) +
                        IS_UPDATING_VI_CODE,
                  );
            if (findCarModel) {
              setSelectedModel(findCarModel);
            } else {
              setSelectedModel({ id: OTHER, label: nameOfCarModel });
            }
          }
        })();
      } else {
        setSelectedModel({ id: "", label: "" });
        setModelCodeInput("");
      }
    }, [selectedCarCompany]);

    useEffect(() => {
      if (
        selectedModel &&
        selectedModel.id !== "" &&
        selectedCarCompany &&
        selectedCarCompany.id !== ""
      ) {
        setSelectedModelCode({ id: "", label: "" });
        setListModelCode([]);
        setModelCodeInput("");
        navigate(pathname, {
          replace: true,
          state: null,
        });
        if (state && state?.modelCode && state?.otherValue) {
          setSelectedModelCode(state?.modelCode);
          setModelCodeInput(state?.otherValue);
          setOtherValue(state?.otherValue);
          return;
        }
        if (selectedModel.id === OTHER) {
          setSelectedModelCode({ id: OTHER, label: "" });
          if (dataFormImage?.modelCode) {
            setModelCodeInput(dataFormImage?.modelCode);
            setOtherValue(dataFormImage?.modelCode);
          }
          if (dataFormImage?.predictedYear) {
            const year = listOptionManufactureYear.find(
              (item) => item.id === dataFormImage.predictedYear.toString(),
            );
            if (year) setSelectedManufactured(year);
          }
          if (dataFormImage?.carType)
            setSpecializedVehicle(dataFormImage?.carType);
          return;
        }

        (async () => {
          const listModelCode: CarModelCodeType[] = await getCarModelCodeByType(
            "specialized",
            selectedCarCompany.id,
            selectedModel.versionKey,
            1000,
          );

          if (!isEmpty(listModelCode)) {
            const currentModelCode: any = listModelCode.find(
              (item: any) => item.modelCode === selectedModel.modelCode,
            );

            setSelectedModelCode({
              id: currentModelCode.modelCode,
              label: currentModelCode.modelCode,
              carTypeName: currentModelCode.carTypeName,
              payload: currentModelCode.payload,
            });
            setModelCodeInput(currentModelCode.modelCode);
            if (
              dataFormImage &&
              dataFormImage?.modelCode &&
              dataFormImage?.modelCode !== currentModelCode.modelCode
            ) {
              setSelectedModelCode({ id: OTHER, label: "Khác" });
              setModelCodeInput(dataFormImage?.modelCode);
              setOtherValue(dataFormImage?.modelCode);
            }
          }
        })();
      } else {
        setSelectedModelCode({ id: "", label: "" });
        setModelCodeInput("");
      }
    }, [selectedModel, selectedCarCompany]);

    useEffect(() => {
      if (state && state?.company) setSelectedCarCompany(state?.company);
      if (state && state?.weight) setWeight(state?.weight);
      if (state && state?.specializedVehicle)
        setSpecializedVehicle(state?.specializedVehicle);
      if (state && state?.selectedManufactured)
        setSelectedManufactured(state?.selectedManufactured);
    }, []);

    useEffect(() => {
      if (!state && !isLoadCarPrice)
        onValueChange(
          JSON.stringify({
            company: selectedCarCompany,
            model: selectedModel,
            modelCode: selectedModelCode,
            weight,
            otherValue,
            specializedVehicle,
            selectedManufactured,
          }),
        );
    }, [
      selectedCarCompany,
      selectedModel,
      selectedModelCode,
      otherValue,
      weight,
      specializedVehicle,
      selectedManufactured,
    ]);

    const isValidate =
      selectedCarCompany?.id !== "" &&
      selectedModel?.id !== "" &&
      specializedVehicle !== "" &&
      selectedManufactured?.id !== "" &&
      ((selectedModelCode?.id !== "" && selectedModelCode?.id !== OTHER) ||
        (selectedModelCode?.id === OTHER && modelCodeInput !== ""));

    const handleModelCodeInputChange = (value: string) => {
      resetCarPrice();
      setModelCodeInput(value);
      setOtherValue(value);
      if (selectedModelCode?.id !== OTHER)
        setSelectedModelCode({ id: OTHER, label: "Khác" });
    };

    const resetCarPrice = () => {
      if (state || isLoadCarPrice) return;

      setCarPriceValue((prev: any) => ({
        ...prev,
        carValue: 0,
        maxPrice: null,
        minPrice: null,
        minListedPrice: null,
        maxListedPrice: null,
        hanoiOnRoadPrice: null,
        generalOnRoadPrice: null,
        hcmOnRoadPrice: null,
      }));
    };

    return (
      <>
        {isTabletOrMobile && (
          <Grid item xs={12} sm={12} md={12}>
            <Button
              variant="outlined"
              endIcon={!open ? <ExpandMoreIcon /> : <ExpandLessIcon />}
              sx={{
                color: theme.palette.mode === "dark" ? "white" : "black",
                border: "1px solid #E5E7EB",
                borderRadius: "8px",
              }}
              onClick={() => setOpen(!open)}
            >
              Tra cứu
            </Button>
          </Grid>
        )}
        {(open || !isTabletOrMobile) && (
          <>
            <Grid item xs={12} sm={5.6} md={12}>
              <AutoCompleteInput
                label={t("form.selection.brand.title")}
                listOption={listCarCompany}
                onChange={(value: any) => {
                  resetCarPrice();
                  setSelectedCarCompany(value);
                }}
                value={selectedCarCompany}
                placeholder={t("form.selection.brand.placeholder")}
                onClose={() => {
                  setOpenCarModel(true);
                }}
                onOpen={() => {
                  setOpenCarModel(false);
                }}
              />
            </Grid>

            <Grid item xs={12} sm={5.6} md={12}>
              <AutoCompleteInput
                label="Hiệu xe - Phiên bản"
                listOption={listCarInfoModel}
                onChange={(value: any) => {
                  resetCarPrice();
                  setSelectedModel(value);
                }}
                value={selectedModel}
                disabled={selectedCarCompany?.id === ""}
                disabledReset={selectedCarCompany?.id === OTHER}
                placeholder={t("form.selection.model.placeholder")}
                open={selectedCarCompany?.id !== "" && openCarModel}
                onClose={() => {
                  setOpenCarModel(false);
                }}
                onOpen={() => {
                  setOpenCarModel(!openCarModel);
                }}
              />
            </Grid>

            <Grid item xs={12} sm={5.6} md={12}>
              <TextFieldInput
                label="Số loại"
                onChange={handleModelCodeInputChange}
                value={modelCodeInput}
                placeholder="Số loại"
              />
            </Grid>

            <Grid item xs={12} sm={5.6} md={12}>
              <NumberInput
                name="weight"
                label="Tải trọng"
                onChange={(value: string) => {
                  resetCarPrice();
                  setWeight(value);
                }}
                value={weight}
                disabled={selectedModelCode?.id === ""}
                placeholder="Tải trọng"
              />
            </Grid>
            <Grid item xs={12} sm={5.6} md={12}>
              <TextFieldInput
                label="Loại xe chuyên dụng"
                onChange={(value: string) => {
                  resetCarPrice();
                  setSpecializedVehicle(value);
                }}
                value={specializedVehicle}
                disabled={selectedModelCode?.id !== OTHER}
                placeholder="Loại xe chuyên dụng"
              />
            </Grid>
            <Grid item xs={12} sm={5.6} md={12}>
              <AutoCompleteInput
                label={t("form.selection.manufacture-year.title")}
                listOption={listOptionManufactureYear}
                onChange={(value: any) => {
                  resetCarPrice();
                  setSelectedManufactured(value);
                }}
                value={selectedManufactured}
                placeholder="Năm sản xuất"
                disabled={selectedModelCode?.id === ""}
              />
            </Grid>

            <Button
              style={{
                width: "100%",
                height: "50px",
                background: `${isValidate ? "#5768FF" : "#f0f0f0"}`,
                borderRadius: "12px",
                fontWeight: 700,
                fontSize: "16px",
                lineHeight: "20px",
                textAlign: "center",
                letterSpacing: "0.005em",
                color: `${isValidate ? "#ffffff" : "#bdbdbd"}`,
                textTransform: "unset",
                wordBreak: "keep-all",
                display: "block",
                marginTop: "15px",
              }}
              disabled={!isValidate}
              type="submit"
            >
              Tra cứu
            </Button>
          </>
        )}
      </>
    );
  },
);

export default memo(SpecializedVehicleForm);
